import type { RouteRecordRaw } from 'vue-router';
import { buildRootURL } from '@centric-os/helpers';
import { AgentRouteParams, AgentRoutePathNames, AgentRouteNames } from './enums';

const Component = () => import('./components/AgentChatPage.vue');

export * from './enums';

// One route for the new-chat landing and every past chat: switching chats
// only changes the optional param, so the page stays mounted (voice mode,
// scroll position and the conversation rail all survive the switch).
export const route: RouteRecordRaw = {
  path: `${buildRootURL(AgentRoutePathNames.AGENT)}/:${AgentRouteParams.CONVERSATION_ID}?`,
  name: AgentRouteNames.AGENT,
  meta: {
    title: 'Assistant',
    requireAuth: true,
  },
  component: Component,
};
